(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
class FaqSection extends HTMLElement {
  connectedCallback() {
    this._tabs   = Array.from(this.querySelectorAll('[data-faq-tab]'));
    this._groups = Array.from(this.querySelectorAll('[data-faq-group]'));
    if (!this._tabs.length || !this._groups.length) return;

    this._bindTabs();
    this._observeGroups();
    this._initFromHash();
  }

  _bindTabs() {
    this._tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        e.preventDefault();
        const key    = tab.dataset.faqTab;
        const target = this.querySelector(`#faq-group-${key}`);
        if (!target) return;
        const offset = this._stickyHeaderHeight();
        const top    = target.getBoundingClientRect().top + window.scrollY - offset - 24;
        window.scrollTo({ top, behavior: 'smooth' });
        this._setActive(key);
      });
    });
  }

  _observeGroups() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) this._setActive(entry.target.dataset.faqGroup);
      });
    }, { rootMargin: '-15% 0px -65% 0px', threshold: 0 });
    this._groups.forEach(g => observer.observe(g));
  }

  _initFromHash() {
    const hash = window.location.hash.replace(/^#faq-group-/, '');
    if (hash && this._tabs.some(t => t.dataset.faqTab === hash)) {
      this._setActive(hash);
    } else if (this._tabs.length) {
      this._setActive(this._tabs[0].dataset.faqTab);
    }
  }

  _setActive(key) {
    this._tabs.forEach(tab => tab.classList.toggle('is-active', tab.dataset.faqTab === key));
  }

  _stickyHeaderHeight() {
    const header = document.querySelector(
      'sticky-header, .shopify-section-header-sticky, header[class*="sticky"]'
    );
    return header ? header.getBoundingClientRect().height : 0;
  }
}

customElements.define('faq-section', FaqSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
